import { render, staticRenderFns } from "./finishedList.vue?vue&type=template&id=0a3e4bc2&scoped=true&lang=html"
import script from "./finishedList.vue?vue&type=script&lang=js"
export * from "./finishedList.vue?vue&type=script&lang=js"
import style0 from "./finishedList.vue?vue&type=style&index=0&id=0a3e4bc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3e4bc2",
  null
  
)

export default component.exports